<template>
    <!-- <sidebar-menu :menu="menu" :collapsed="true"  @toggle-collapse="onToggleCollapse" @item-click="onItemClick"/> -->
    <div class="sidebar" >
      <sidebar-menu :menu="menus" :collapsed="false" :showOneChild="true" :showChild="false" :hideToggle="true" theme="white-theme" width="260" @toggle-collapse="onToggleCollapse" @item-click="onItemClick"/>
    </div>
</template>

<script>
//REF -> https://yaminncco.github.io/vue-sidebar-menu/#/props
// https://medium.com/front-end-weekly/how-to-use-fon-awesome-5-on-vuejs-project-ff0f28310821
import { SidebarMenu } from 'vue-sidebar-menu'
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService'

export default {
  name: "Sidebar",

  components: {
    SidebarMenu
  },
  
  data() {
    return {
        menus: []
    }
  },
  computed: {
    ...mapGetters([
      'getSideBarMenuOptions',
    ])
  },  
  created : function (){
    this.menus = this.getSideBarMenuOptions;




  },
  mounted(){
    const items = document.querySelectorAll('.sidebar .vsm--item span.last');
      items.forEach(element => {
        const target = element.closest('.vsm--item');
        target.classList.add('border-bottom');
        // console.log(target);
        // target.style.display = 'none';
      });


      // SideBar content
      const getSidebar = ApiService.getObjectifMonitoringApi().getClassificationPlan();
      console.log("mounted -> getSidebar", getSidebar)


  },
  methods: {
      onToggleCollapse() {
      // console.log("onToggleCollapse -> collapsed", collapsed)
      },

      onItemClick(event, item) {
      // console.log(event,node,item)
      this.$store.dispatch('setScrollEnter', event.screenY);
      item.to.path? this.$router.push(item.to.path): '';
      }
  }  
}
</script>

